

import * as types from "./mutation_types"
import notify from "@/utils/notify"
import router from "@/router"
import backend from "@/utils/backend"
import { LOGIN,LOGIN_OSCAR } from "@/utils/apiUrl"


export const login =  ({ commit }, data) =>{
    commit(types.SET_SHOW_LOADING)
    commit(types.SET_HIDE_MESSAGE)
    backend({ method: "POST", url: LOGIN, data,isAuth:false,client:true }).then(({ data }) => {
       
        commit(types.SET_ITEMS, data.user)
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_MESSAGE, "Is Ok")
        commit(types.SET_IS_LOGIN, true)
        localStorage.setItem("token",data.access_token ??  data.token)
        router.push({name:"Dashboard"})
    }).catch((err) => {

        commit(types.SET_IS_ERROR)
        commit(types.SET_IS_LOGIN, false)
        notify(err?.response?.data?.message ?? err.message ?? err)
        localStorage.clear()
        router.push({name:"AuthLogin"})

        commit(types.SET_MESSAGE, err.message ?? err)

    }).finally(() => {

        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)
    })
}

export const redirectLDAP = async ({ commit }) => {
    try {
        commit(types.SET_SHOW_LOADING)
        commit(types.SET_HIDE_MESSAGE)

        const url =  process.env.LDAP_URL ?? "https://pprodofficial.service-public.bj/official/login?client_id=denonciation&redirect_uri=http:%2F%2Fbackoffice.denonciation.bj%2Fad_login&scope=openid&response_type=code&authError=1"
      

        
        const popup = window.open(
            url,
            'Connexion',
            'width=500,height=600'
        )


        return new Promise((resolve) => {
            const listener = async (event) => {

                commit(types.SET_HIDE_LOADING)
                if (event.data.type === 'auth-success') {
                    console.log('event', event)


                    console.log('event.data', event.data)
                    window.removeEventListener('message', listener)
                    popup.close()

                    // // On peut stocker token ou infos utilisat
                    resolve(event.data)
                }
            }

            window.addEventListener('message', listener)
        })
    } catch (error) {


        console.log('error', error)
        commit(types.SET_IS_ERROR)
        commit(types.SET_IS_LOGIN, false)

        commit(types.SET_MESSAGE, "L'utilisateur n'est pas  connecté")
        commit(types.SET_HIDE_LOADING)
    }

    
}
export const loginOscar =  ({ commit }, data) =>{
    commit(types.SET_SHOW_LOADING)
    commit(types.SET_HIDE_MESSAGE)
    backend({ method: "POST", url: LOGIN_OSCAR, data,isAuth:false,client:true }).then(({ data }) => {
       
        commit(types.SET_ITEMS, data.user)
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_MESSAGE, "Is Ok")
        commit(types.SET_IS_LOGIN, true)
        localStorage.setItem("token",data.access_token ??  data.token)
        router.push({name:"Dashboard"})
    }).catch((err) => {

        commit(types.SET_IS_ERROR)
        commit(types.SET_IS_LOGIN, false)
        notify(err?.response?.data?.message ?? err.message ?? err)
        localStorage.clear()
        router.push({name:"AuthLogin"})

        commit(types.SET_MESSAGE, err.message ?? err)

    }).finally(() => {

        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)
    })
}

export const resetData = ({ commit }) => {
    commit(types.RESET)
}



